import {observer} from "mobx-react-lite";
import React from "react";
import {
    WAVE_HEIGHT,
    WAVE_OFFSET_Y,
    WAVE_SVG_HEIGHT,
    WAVE_SVG_WIDTH,
    WAVE_VIEWBOX
} from "../utils/svg";
import {WaveAxis} from "./WaveAxis";
import {Wave} from "./Wave";
import {Modulator} from "../stores/Modulator";

interface ModulatorWaveBaseProps {
    modulator: Modulator;           // "CC<CC>" by default
}

export const ModulatorWaveBase = observer(({modulator}: ModulatorWaveBaseProps) => {

    // console.log("ModulatorWaveBase render", modulator.regenCounter);

    const midY = (WAVE_OFFSET_Y + modulator.fxMid() * WAVE_HEIGHT - 5);
    const highY = Math.max((WAVE_OFFSET_Y + modulator.fxMax() * WAVE_HEIGHT - 5), midY + 12);   // to avoid text overlapping
    const lowY = Math.min((WAVE_OFFSET_Y + modulator.fxMin() * WAVE_HEIGHT - 5), midY - 12)     // to avoid text overlapping

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const dummy = modulator.regenCounter;   // hack to force a refresh when regenCounter changes.

    return (
        <svg width={`${WAVE_SVG_WIDTH}px`} height={`${WAVE_SVG_HEIGHT}px`} viewBox={WAVE_VIEWBOX} className="wave-base">
            <WaveAxis offset={modulator.offset} />
            <Wave f={modulator.f} phase={modulator.phase} offset={modulator.offset} amplitude={modulator.amplitude} />
            <text x={30} y={WAVE_SVG_HEIGHT - highY} textAnchor="end" fontSize="0.8rem">{Math.round(modulator.fxMax() * modulator.range)}</text>
            <text x={30} y={WAVE_SVG_HEIGHT - midY} textAnchor="end" fontSize="0.8rem">{Math.round(modulator.fxMid() * modulator.range)}</text>
            <text x={30} y={WAVE_SVG_HEIGHT - lowY} textAnchor="end" fontSize="0.8rem">{Math.round(modulator.fxMin() * modulator.range)}</text>
        </svg>
    );

});
